module.exports = __webpack_public_path__ + "static/media/right_hand.a87266b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/right_hand.png
// module id = 1278
// module chunks = 0